import { CustomerProjectGateway } from './customer-project-gateway.interface';

const baseUrl = 'customer/projects';
export class HttpCustomerProjectGateway implements CustomerProjectGateway {
  private baseUrl = baseUrl;

  getAllProjects(args: { groupName: string }) {
    return {
      url: `${baseUrl}`,
      method: 'GET',
      params: { groupName: args.groupName },
    };
  }

  getProjectByToken(args: { token: string; groupName: string }) {
    return {
      url: `${baseUrl}/token/${args.token}`,
      method: 'GET',
      params: {
        groupName: args.groupName,
      },
    };
  }

  getTasksByProject(args: { projectId: string; groupName: string }) {
    return {
      url: `${baseUrl}/${args.projectId}/all-tasks`,
      method: 'GET',
      params: {
        groupName: args.groupName,
      },
    };
  }

  postCustomerAskSomething(args: {
    projectId: string;
    descriptif: string;
    motif: string;
  }) {
    return {
      url: `${baseUrl}/${args.projectId}/customer-ask-something`,
      method: 'POST',
      data: {
        descriptif: args.descriptif,
        motif: args.motif,
      },
    };
  }

  getCustomerNotificationsByProject(args: { projectId: string }) {
    return {
      url: `${baseUrl}/${args.projectId}/notifications`,
      method: 'GET',
    };
  }

  patchCustomerNotificationAsSeen(args: { notificationId: string }) {
    return {
      url: `${baseUrl}/${args.notificationId}/seen-notification`,
      method: 'PATCH',
    };
  }
}
